<template>
    <div class="l-inline l-center-v l-gap-2 simulation-mode-bar">
        <div v-if="isSharded" class="l-inline l-gap-1 shard-links">
            <a
                v-for="shard in shardNames"
                :key="shard"
                :class="{ bold: shard === serverName }"
                :href="
                    `https://api.${shard}.axroad.srv.adnexo.ch/saml-login/?idp=https://sts.windows.net/2a60a461-c01c-46b2-885a-18fb224d7355/&amp;next=https://app.ax-road.ch`
                "
            >
                {{ shard }}
            </a>
        </div>
        <div class="l-inline l-center l-grow-1">
            <span>
                <strong>{{ $t('title') }}</strong>
                <strong
                    :class="{
                        'username-label':
                            simulatableUsersSortedByUsername.length,
                    }"
                >
                    {{ userInfo.username }}
                </strong>
            </span>

            <user-select
                v-if="simulatableUsersSortedByUsername.length"
                v-model="selectedUser"
                use-simulatable-users
                show-details
                @input="handleUserSelect"
            />

            <IconButton
                class="exit-button"
                :title="$t('stop')"
                @click="handleExit"
            >
                <RemoveIcon color="rgba(0, 0, 0, 0.675)" />
            </IconButton>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import IconButton from './IconButton'
import RemoveIcon from './icons/RemoveIcon'
import UserSelect from './UserSelect'

export default {
    name: 'SimulationModeBar',
    components: {
        IconButton,
        RemoveIcon,
        UserSelect,
    },
    data() {
        return {
            selectedUser: null,
        }
    },
    computed: {
        ...mapState('auth', ['userInfo', 'backend']),
        ...mapGetters('user', ['simulatableUsersSortedByUsername']),
        isSharded() {
            return process.env.VUE_APP_API_URL.split(',').length > 1
        },
        serverName() {
            const url = this.backend.api_url
            const match = url.match(/^https:\/\/api\.([^.]+)\./)
            return match?.[1].toUpperCase()
        },
        shardNames() {
            const shards = process.env.VUE_APP_API_URL.split(',').map(url => {
                const match = url.match(/^https:\/\/api\.([^.]+)\./)
                return match?.[1].toUpperCase()
            })
            return shards
        },
    },
    watch: {
        userInfo({ id }) {
            this.selectedUser = id
        },
    },
    mounted() {
        this.selectedUser = this.userInfo?.id
    },
    methods: {
        ...mapActions('auth', ['simulateUser', 'stopSimulatingUser']),
        ...mapActions('common', ['loadData']),
        ...mapMutations('common', ['setDataLoading']),
        async handleUserSelect(id) {
            this.setDataLoading(true)
            await this.simulateUser(id)
            this.$root.$i18n.locale = this.userInfo.language
            await this.loadData()
            this.$router.push('/')
        },
        handleExit() {
            this.stopSimulatingUser()
            this.$root.$i18n.locale = this.userInfo.language
            this.loadData()
        },
    },
}
</script>

<i18n>
{
    "en": {
        "stop": "Exit simulation mode",
        "title": "User Simulation."
    },
    "de": {
        "stop": "Benutzer Simulation beenden",
        "title": "Benutzer Simulation."
    },
    "fr": {
        "stop": "Quitter le mode simulation",
        "title": "Mode Simulation"
    },
    "it": {
        "stop": "Uscire dal modo simulazione",
        "title": "Modo simulazione."
    }
}
</i18n>

<style lang="scss" scoped>
.simulation-mode-bar {
    padding: 0 3rem 0 1rem;
    height: 5vh;
    background-color: rgb(250, 225, 150);
    border-bottom: 1px solid rgb(215, 195, 130);
    color: rgba(0, 0, 0, 0.675);
    z-index: 1000;
}

.exit-button {
    position: absolute;
    right: 1rem;
}

.bold {
    font-weight: 700;
}

.username-label {
    display: none;
    @include respond-to('for-mobile-down') {
        display: initial;
    }
}

.multiselect {
    @include respond-to('for-mobile-down') {
        display: none;
    }
}
</style>

<style lang="scss">
.simulation-mode-bar {
    .multiselect {
        margin-left: 0.5em;
        max-width: 400px;
        min-height: 32px;
    }

    .multiselect__tags {
        min-height: 32px;
        padding: 0 40px 0 8px;
    }

    .multiselect__select {
        height: 28px;
    }

    .multiselect__input,
    .multiselect__single {
        margin: 0;
        padding: 5px !important;
    }
}
</style>
